import { registerComponent } from '@gig/magic-common';
import FaqSearchComponent from './faq-search.vue.js';

var FaqSearch = registerComponent(FaqSearchComponent);

export { FaqSearch };
